import {
	BN,
	BigNum,
	PRICE_PRECISION_EXP,
	QUOTE_PRECISION_EXP,
} from '@drift-labs/sdk';

export const ZERO_BIGNUM = new BigNum(0);
export const ZERO_PRICE_BIGNUM = BigNum.from(0, PRICE_PRECISION_EXP);
export const ZERO_QUOTE_BIGNUM = BigNum.from(0, QUOTE_PRECISION_EXP);
export const ZERO = new BN(0);
export const HUNDRED = new BN(100);
export const TEN_THOUSAND_BIGNUM = BigNum.fromPrint(
	'10000',
	QUOTE_PRECISION_EXP
);

// Time
export const ONE_MINUTE_MS = 60 * 1000;
export const ONE_HOUR_MS = 60 * ONE_MINUTE_MS;
export const ONE_DAY_MS = 24 * ONE_HOUR_MS;
